/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pie-chart .background{fill:#ddd}.pie-chart .total{text-anchor:start}.pie-chart .labels{font-size:smaller}.pie-chart .lines{stroke:#000;stroke-width:1px;fill:none;opacity:.3}.pie-chart .center{text-anchor:middle;text-shadow:0 1px 0 #fff,0 -1px 0 #fff,1px 0 0 #fff,-1px 0 0 #fff}"];
export { styles as styles };
